import api from '@/api/axios';

const state = {
  projectInfoListList: [],
  dashboardCrawlingList: [],
  vizPanelData: null,          // ⬅️ vizPanel 응답 저장
  isLoading: false,
  error: null,
};

const mutations = {
  SET_PROJECT_INFO_LIST(state, projectInfoListList) {
    state.projectInfoListList = projectInfoListList;
  },
  // 오타 유지 중인 기존 커밋 키 ← 기존 코드 호환을 위해 그대로 둠
  SET_DASH_BOARD_CRAWILNG_LIST(state, dashboardCrawlingList) {
    state.dashboardCrawlingList = dashboardCrawlingList;
  },
  // 새로 추가 - 더 읽기 좋은 이름
  SET_DASHBOARD_CRAWLING_LIST(state, dashboardCrawlingList) {
    state.dashboardCrawlingList = dashboardCrawlingList;
  },
  SET_VIZ_PANEL_DATA(state, payload) {               // ⬅️ vizPanel 응답 저장
    state.vizPanelData = payload;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  // 프로젝트 정보 리스트
  async getProjectInfoList({ commit, rootState }, project_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) throw new Error('No authentication token found');

      const { data } = await api.get(`/api/v1/dashborad/project_info_list/${project_id}`);
      commit('SET_PROJECT_INFO_LIST', data);
    } catch (error) {
      console.error('Failed to fetch getProjectInfoList:', error);
      if (error.response?.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to getProjectInfoList');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 대시보드 크롤링 리스트 (GET)
  async getDashboardCrawlingList({ commit, rootState }, project_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) throw new Error('No authentication token found');

      const { data } = await api.get(`/api/v1/dashborad/dashboard_crawling_list/${project_id}`);
      // 호환 목적: 기존/새 키 둘 다 커밋
      commit('SET_DASH_BOARD_CRAWILNG_LIST', data);
      commit('SET_DASHBOARD_CRAWLING_LIST', data);
    } catch (error) {
      console.error('Failed to fetch getDashboardCrawlingList:', error);
      if (error.response?.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to getDashboardCrawlingList');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // ✅ vizPanel (POST) — YYYYMMDD 형식으로 전송
async postVizPanel({ commit, rootState }, payload) {
  commit('SET_LOADING', true);
  commit('SET_ERROR', null);

  try {
    const token = rootState.auth.token;
    if (!token) throw new Error('No authentication token found');

    const {
      cvs_paths = [],
      channel_list = [],
      start_date,
      end_date,
      keyword,       // 키워드 추가
      vizPanel_type, // 옵션
    } = payload || {};

    // 기본 유효성
    if (!start_date || !end_date) {
      throw new Error('start_date / end_date가 필요합니다.');
    }
    if (!Array.isArray(cvs_paths) || cvs_paths.length === 0) {
      throw new Error('cvs_paths에 최소 1개 이상의 경로가 필요합니다.');
    }

    // YYYYMMDD 로 변환
    const toYYYYMMDD = (d) => {
      const dt = typeof d === 'string' ? new Date(d) : d;
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}${m}${day}`;
    };

    const body = {
      cvs_paths: [...new Set((cvs_paths || []).filter(Boolean))],
      channel_list: [...(channel_list || [])], // Proxy → Array
      start_date: toYYYYMMDD(start_date),
      end_date: toYYYYMMDD(end_date),
      keyword: keyword,
      ...(vizPanel_type ? { vizPanel_type } : {}),
    };

    const { data } = await api.post(`/api/v1/dashborad/vizPanel`, body);

    commit('SET_VIZ_PANEL_DATA', data);
    return data;
  } catch (error) {
    const detail =
      error?.response?.data?.detail ||
      error?.message ||
      'Failed to post vizPanel';
    console.error('Failed to post vizPanel:', error?.response?.data || error);
    commit('SET_ERROR', detail);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
}

};

const getters = {
  projectInfoListList: state => state.projectInfoListList,
  dashboardCrawlingList: state => state.dashboardCrawlingList,
  vizPanelData: state => state.vizPanelData,          // ⬅️ getter 추가
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
